export const NavbarMenu = [
  {label: "About", link: "/about"},
  {label: "Skills", link: "/skills"},
  {label: "Resume", link: "/resume"},
  {label: "Work", link: "/work"},
];